module.exports = __webpack_public_path__ + "static/media/tendericon03@2x.306709b3.png";